<template>
<b-card>
            <div slot="header">
                <b-row >
                    <b-col> </b-col>
                    <b-col cols="2"><h3>Listado de Personal</h3></b-col>
                    <b-col> </b-col>
                </b-row>
            </div>

       <b-container fluid>
<b-row>     
                    <!-- <b-col cols="12" sm="10" md="10"	lg="10"	xl="2">
                        <b-form-group horizontal label="Orden" class="mb-0">
                            <b-input-group>
                            <b-form-select v-model="orden" slot="append" @input="listarPersonal">
                                <option :value="'asc'">Más Antiguo</option>
                                <option :value="'desc'">Más Reciente</option>
                            </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col> -->
                    <b-col cols="12" sm="10" md="10"	lg="10"	xl="2">
                        <b-form-group horizontal label="Mostrar" class="mb-0">
                            <b-input-group>
                                <b-form-select v-model="perPage" slot="append">
                                <option :value="10">10</option>
                                    <option :value="25">25</option>
                                    <option :value="50">50</option>
                                    <option :value="100">100</option>
                                </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="10" md="10"	lg="10"	xl="2">
                        <div class="col-md-12 text-center">
                            <b-button variant="secondary" @click="listarPersonal"><i class="fa fa-sync-alt"></i> </b-button>
                        </div>
                    </b-col>
                    <b-col cols="12" sm="10" md="10"	lg="10"	xl="4">
                        <b-form-group horizontal label="Busqueda de Personal:" class="mb-0">
                        <b-input-group>
                             <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fas fa-passport"></i></span>
                                    </div>
                            <b-form-input v-model="filter" placeholder="Ingrese parámetro de busqueda" />
                            <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="1" sm="2"	md="2"	lg="2"	xl="2" >
                       <router-link to="personalnuevo" ><b-button ><i class="fa fa-plus"></i> Nuevo Personal</b-button></router-link>
                    </b-col>
                </b-row>
                <br>

                 <b-table
                      id="my-table"
                      :busy="isBusy2"
                      :fields="colaboladores_fields"
                      :items="colaboradores"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :filter="filter"
                      
                      small
                    >
                    <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Listando Personal...</strong>
                        </div>
                     <template slot="nombres" slot-scope="row">
                            <router-link :to="'personal/' + row.item.id">{{ row.item.nombres }} </router-link>
                        </template>
                       <template slot="acciones" slot-scope="row">
                            <b-button-group>
                                <!-- <b-button v-b-tooltip.hover variant="primary" @click="editClient(row.item)"><i class="fa fa-user-clock" title="Asistencia"></i></b-button> -->
                                <router-link :to="'personal/' + row.item.id"><b-button v-b-tooltip.hover variant="primary" ><i class="fa fa-pencil-alt" title="Asistencia y Editar Personal"></i></b-button></router-link>
                                <b-button @click="deleteClient(row.item)" v-b-tooltip.hover variant="danger"><i class="fa fa-trash" title="Eliminar Cliente"></i></b-button>
                            </b-button-group>
                        </template> 
                    </b-table>
                    <p class="mt-3">Current Page: {{ currentPage }}</p>
                     <b-pagination
                          v-model="currentPage"
                          :total-rows="tRows"
                          :per-page="perPage"
                          aria-controls="my-table"
                        ></b-pagination>

       </b-container>   
       
                
                 


</b-card>

  
</template>

<script>
import axios from 'axios'
import { DocIdenPersonal } from '@/shared/utils'
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'

export default {
  name: 'colaborador',
  components: {
    PulseLoader
  },
  

  data(){
    return{
     isBusy2: false,
     perPage: 10,
     currentPage:1,
     tRows:'',
     filter: '',
     colaboradores: [],
     colaboladores_fields: [
                   // {key: 'red', label: '', sortable: true},
                    {key: 'numero_documento', label: 'Doc. Identidad', sortable: false},
                    {key: 'nombres', label: 'Nombres', sortable: true},
                    {key: 'apellido_paterno', label: 'A. Paterno', sortable: true},
                    {key: 'apellido_materno', label: 'A. Materno', sortable: true},
                    {key: 'telefono', label: 'Telefono', sortable: false},
                    {key: 'direccion', label: 'Dirección', sortable: false},
                    {key: 'sueldo', label: 'Sueldo', sortable: false},
                    {key: 'empresa', label: 'Empresa', sortable: false},
                    {key: 'acciones', label: 'Acciones'}
                ],
    }
  },
  mounted() {
    this.listarPersonal();
  },
methods:{
  listarPersonal: function() {
    this.isBusy2 = true
    axios
    .post(process.env.VUE_APP_API_URL + 'personal/listar/', {
                    token: this.$store.getters.userToken,
                    page: this.currentPage,
                    order: this.orden
                    // limit: this.limite,
                    
                })
                .then(response => (
                  this.colaboradores = response.data.results,
                  this.tRows = this.colaboradores.length,
                  this.isBusy2 = false
                ))
                .catch(error => {
                    this.isBusy2 = false
                })       
                           
  },
  deleteClient: function (value) {
                swal({
                title: "Seguro de borrar a "+value.razonSocial,
                text: "Este proceso no se puede revertir!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                })
                .then((willDelete) => {
                if (willDelete) {
                    this.deletePersonal(value),
                    this.isBusy2 = true
                }
                });
            },
            deletePersonal: function (value) {
                this.isBusy2 = true
                axios
                .post(process.env.VUE_APP_API_URL + 'personal/eliminar/', {
                    token: this.$store.getters.userToken,
                    id: value.id
                })
                .then(response => (
                    this.$snotify.success(response.data.msg, 'Éxito'),
                    this.listarPersonal()
                ))
                .catch(error => (
                    this.cargando = false,
                    this.isBusy2 = false,
                    this.$snotify.error(error.response.data.msg, 'Error')
                ))
            },
 
  
}

}

    
</script>